
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BackButton,
  },
})
export default class Header extends Vue {
  @Prop({ type: String, required: false, default: 'Job Booking' }) public title!: string;
  @Prop({ type: String, required: false, default: 'Order a job in a convenient way for you:' })
  public subtitle!: string;
}
